import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CButton, CModal, CModalBody } from '@coreui/react-pro';

import { SelectSearchField } from '../../../General/Forms';
import { LOCAL_CART, LOCAL_COUPON, LOCAL_COUPON_VOUCHERS, LOCAL_ORG_USER, ORG_USER_ROLES, POPUP_TYPE } from '../../../../constants';
import { addTimezoneLocal } from '../../../../utils';

import PageBack from '../../../General/Link/PageBack';

import { setCurrentCountry } from '../../Subscriber/GlobalStates/CurrentCountry/actions';
import { setShow } from '../../../../actions/general';
import { setOrganizationTrainingGroups } from '../../Organizations/TrainingGroups/actions';
import { actionClearCartCouponVouchers } from '../Cart/actions';

const SelectOrganization = ({ handleSelectOrganization }) => {
     const dispatch = useDispatch();
     const managedOrganizations = useSelector((state) => state.subscriber.managedOrganizations);

     const [orgSelected, setOrgSelected] = useState();

     const orgUser = JSON.parse(localStorage.getItem(LOCAL_ORG_USER));

     let listOrgs = [];

     if (managedOrganizations) {
          listOrgs = managedOrganizations
               .filter((item) => item.role === ORG_USER_ROLES.OWNER)
               .map((item) => ({
                    value: item.organization.id,
                    label: item.organization.name,
               }));

          if (orgUser && listOrgs.length > 1) {
               listOrgs = listOrgs.filter((item) => item.value !== orgUser.organizationId);
          }
     }

     const selectOrganization = () => {
          if (!orgSelected?.value) {
               return;
          }

          const isSetCartLocal = false;
          const managedOrganizationSelected = managedOrganizations.find(
               (managedOrganization) => managedOrganization.organization.id === orgSelected.value
          );

          if (managedOrganizationSelected) {
               localStorage.setItem(LOCAL_ORG_USER, JSON.stringify(managedOrganizationSelected));
               addTimezoneLocal(managedOrganizationSelected.organization?.timezone);
          }

          if (managedOrganizationSelected?.organization?.country) {
               dispatch(setCurrentCountry(managedOrganizationSelected.organization.country));
          }

          dispatch(setOrganizationTrainingGroups([]));
          dispatch(setShow(null));

          localStorage.removeItem(LOCAL_CART);
          localStorage.removeItem(LOCAL_COUPON);
          localStorage.removeItem(LOCAL_COUPON_VOUCHERS);
          dispatch(actionClearCartCouponVouchers());

          handleSelectOrganization(orgSelected.value, isSetCartLocal);
     };

     const handleBackClick = () => {
          dispatch(setShow(POPUP_TYPE.SELECT_OR_CREATE_ORG));
     };

     const handleCloseButtonClick = () => {
          dispatch(setShow(null));
     };

     return (
          <CModal alignment="center" visible={true} className="popup-custom select-org-popup" onClose={handleCloseButtonClick}>
               <CButton className="close-modal-button" onClick={handleCloseButtonClick} />
               <CModalBody>
                    <PageBack className="back-link-popup" onClick={handleBackClick} title="BACK" />
                    <h2 className="popup-title">Select an Organization</h2>
                    <p className="popup-description">
                         Select one of your existing Organizations for this order. You can only select from Organization that you "own" in the
                         CAMS-care system. Managers of Organizations cannot place orders on behalf of the Organization.
                    </p>

                    <SelectSearchField
                         id="organization"
                         label="Organization"
                         classNameWrap="input-custom-wrap"
                         classNameInput="input-custom select-search-custom"
                         placeholder="Select Organization..."
                         options={listOrgs}
                         value={orgSelected}
                         selectInputType={false}
                         isRequired
                         onChange={setOrgSelected}
                    />

                    <CButton className="btn-blue-highlight btn-h-50 btn-border" disabled={!orgSelected} onClick={selectOrganization}>
                         Order for this organization
                    </CButton>
               </CModalBody>
          </CModal>
     );
};

export default SelectOrganization;
